module.exports = __webpack_public_path__ + "static/media/about_hero_dark.a7c000a0.svg";